import Vue from 'vue'
const formatDate = (value) => Vue.filter('onlyDay')(value)

const translationPath = '$vuetify.pages.SystemLogs.messages'
const modelsPath = `$vuetify.pages.SystemLogs.models`

export function checkType(type, actionItem) {
    try {
        const types = {
            'login': login,
            'create-code': code,
            'remove-code': code,
            'create-account': createAccount,
            'refill-account-balance': refillAccountBalance,
            'change-action-type-status': changeSettings,
            'change-personal-data': changeAccountData,
            'change-admin-data': changeAccountData,
            'create-news': processNews,
            'remove-news': processNews,
            'connect-google-account': connectSocials,
            'connect-facebook-account': connectSocials,
            'push-notification-send': pushNotification,
            'change-servers-fee': changeServersFee,
            'set-to-zero-server-balance': setToZeroServerBalance,
            'change-permission': changeSettings,
            'change-role': changeRole,
            'create-role': processRole,
            'remove-role': remove,
            'change-fee': changeFee,
            'create-client-group': createClientGroup,
            'edit-client-group': editClientGroup,
            'remove-client-group': remove,
            'create-cashback-system': createCashbackSystem,
            'edit-cashback-system': editCashbackSystem,
            'change-cashback-system-activity': changeCashbackSystemActivity,
            'create-ra-system': createRaSystem,
            'edit-ra-system': editRaSystem,
            'change-ra-system-activity': changeRaSystemActivity,
            'complete-ra-system': remove,

            'create-lt-system': createLtSystem,
            'edit-lt-system': editLtSystem,
            'change-lt-system-activity': changeLtSystemActivity,
            'complete-lt-system': remove,

            'create-cashback-step': createCashbackStep,
            'edit-cashback-step': editCashbackStep,
            'remove-cashback-step': removeCashbackStep,

            'create-ra-step': createRaStep,
            'edit-ra-step': editRaStep,
            'remove-ra-step': removeRaStep,

            'create-lt-step': createLtStep,
            'edit-lt-step': editLtStep,
            'remove-lt-step': removeLtStep,
            'complete-cashback-system': remove,
            'funds-purchase': fundsPurchase,
            'funds-charge': fundsCharge,
            'lock-account': lockAccount,
            'change-account-status': changeAccountStatus,
            'change-account-price': changeAccountPrice
        }

        return types[type].call(this, type, actionItem)
    } catch (e) {
        return e.message
    }
}

function createRaSystem(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.RASystem`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function editRaSystem(type, actionItem) {
    const { action: { name, oldData, newData }} = actionItem

    if (!name || !oldData || !newData) {
        return ''
    }

    const copiedNewData = { ...newData }

    const translate = (params, key) => this.$vuetify.t(`${translationPath}.${key}`, ...params)

    const changes = Object.entries(oldData).map(it => {
        const label = it[0]
        let value = it[1]

        const fieldTranslation = this.$vuetify.t(`${modelsPath}.RASystem.${label}`)

        if (['fromDate', 'toDate'].includes(label)) {
            value = formatDate(value)
            copiedNewData[label] = formatDate(copiedNewData[label])
        }

        return translate([
            fieldTranslation,
            value,
            copiedNewData[label]
        ], `${type}.change`)
    })

    return `${translate([name], `${type}.result`)}:\n${changes.join('\n')}`
}

function changeRaSystemActivity(type, actionItem) {
    const { action: { name, enabled }} = actionItem

    return this.$vuetify.t(`${translationPath}.${type}`, name, isEnabled.call(this, enabled))
}

function createLtSystem(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.LTSystem`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function editLtSystem(type, actionItem) {
    const { action: { name, oldData, newData }} = actionItem

    if (!name || !oldData || !newData) {
        return ''
    }

    const copiedNewData = { ...newData }

    const translate = (params, key) => this.$vuetify.t(`${translationPath}.${key}`, ...params)

    const changes = Object.entries(oldData).map(it => {
        const label = it[0]
        let value = it[1]

        const fieldTranslation = this.$vuetify.t(`${modelsPath}.RASystem.${label}`)

        if (['fromDate', 'toDate'].includes(label)) {
            value = formatDate(value)
            copiedNewData[label] = formatDate(copiedNewData[label])
        }

        return translate([
            fieldTranslation,
            value,
            copiedNewData[label]
        ], `${type}.change`)
    })

    return `${translate([name], `${type}.result`)}:\n${changes.join('\n')}`
}

function changeLtSystemActivity(type, actionItem) {
    const { action: { name, enabled }} = actionItem

    return this.$vuetify.t(`${translationPath}.${type}`, name, isEnabled.call(this, enabled))
}

function createRaStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.RASystem.Step`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function editRaStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.RASystem.Step`

    const result = [...Object.keys(action).filter(i => !/^(old|new)/.test(i)).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    }), ...Object.keys(action).filter(i => /^old/.test(i)).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it.replace('old', '').charAt(0).toLowerCase() + it.replace('old', '').slice(1)}`)

        return action[it] !== action[it.replace('old', 'new')] ? `${fieldTranslation}: ${action[it]} -> ${action[it.replace('old', 'new')]}` : ''
    })]

    return result.join('\n')
}

function removeRaStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.RASystem.Step`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function createLtStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.LTSystem.Step`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function editLtStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.LTSystem.Step`

    const result = [...Object.keys(action).filter(i => !/^(old|new)/.test(i)).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    }), ...Object.keys(action).filter(i => /^old/.test(i)).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it.replace('old', '').charAt(0).toLowerCase() + it.replace('old', '').slice(1)}`)

        return action[it] !== action[it.replace('old', 'new')] ? `${fieldTranslation}: ${action[it]} -> ${action[it.replace('old', 'new')]}` : ''
    })]

    return result.join('\n')
}

function removeLtStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.LTSystem.Step`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function createCashbackStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.CashbackSystem.Step`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function editCashbackStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.CashbackSystem.Step`

    const result = [...Object.keys(action).filter(i => !/^(old|new)/.test(i)).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    }), ...Object.keys(action).filter(i => /^old/.test(i)).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it.replace('old', '').charAt(0).toLowerCase() + it.replace('old', '').slice(1)}`)

        return action[it] !== action[it.replace('old', 'new')] ? `${fieldTranslation}: ${action[it]} -> ${action[it.replace('old', 'new')]}` : ''
    })]

    return result.join('\n')
}

function removeCashbackStep(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.CashbackSystem.Step`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function changeAccountStatus(type, { action }) {
    const { email, status, oldStatus } = action
    const translationParams = [email];

    [oldStatus, status].forEach(it => {
        const path = `$vuetify.pages.Moderation.statuses.${it}`

        translationParams.push(this.$vuetify.t(path))
    })

    return this.$vuetify.t(`${translationPath}.${type}`, ...translationParams)
}

function changeAccountPrice(type, { action }) {
    const { email, oldAmount, amount, field } = action

    const translationParams = [
        this.$vuetify.t(`${translationPath}.${field}`),
        email, oldAmount, amount
    ]

    return this.$vuetify.t(`${translationPath}.${type}`, ...translationParams)
}

function changeRole(type, actionItem) {
    const { account: { email }, action: { name, oldData, newData }} = actionItem
    const translate = (params, key) => this.$vuetify.t(`${translationPath}.${key}`, ...params)
    const translationStrings = []

    if (oldData && newData) {
        if (oldData.name && newData.name) {
            translationStrings.push(translate([oldData.name, newData.name], 'change-role.name'))
        }

        if (oldData.permissions && newData.permissions) {
            const oldPermissionsTranslation = permissionsTranslation.call(this, oldData.permissions)
            const newPermissionsTranslation = permissionsTranslation.call(this, newData.permissions)

            translationStrings.push(translate([
                oldPermissionsTranslation, newPermissionsTranslation
            ], 'change-role.permissions'))
        }

        if (oldData.categories && newData.categories) {
            const oldCategoriesList = oldData.categories.map('name')
            const newCategoriesList = newData.categories.map('name')

            translationStrings.push(translate([
                oldCategoriesList, newCategoriesList
            ], 'change-role.categories'))
        }

        if (Object.prototype.hasOwnProperty.call(oldData, 'enabled') &&
            Object.prototype.hasOwnProperty.call(newData, 'enabled')) {
            const activityTranslation = translate([
                oldData.enabled,
                newData.enabled
            ], 'change-role.activity')

            translationStrings.push(`${activityTranslation} ${isEnabled.call(this, newData.enabled)}`)
        }

        return `${translate([email, name], 'change-role.user')}:\n ${translationStrings.join(', ')}`
    }
}

function processRole(type, actionItem) {
    /**
     * This function is used for role creation and role removal logs translation.
     */
    const { account: { email }, action: { name, permissions }} = actionItem
    const permissionsTranslationString = permissions && permissionsTranslation.call(this, permissions)

    const translationParams = [name]

    if (permissions) {
        translationParams.push(permissionsTranslationString)
    }

    return this.$vuetify.t(`${translationPath}.${type}`, email, ...translationParams)
}

function changeFee(type, actionItem) {
    const { account: { email }, action: { oldFee, newFee, email: partnerEmail }} = actionItem
    return this.$vuetify.t(`${translationPath}.${type}`, email, partnerEmail, oldFee, newFee)
}

function createClientGroup(type, actionItem) {
    const { action } = actionItem
    const copiedAction = { ...action }

    const modelPath = `${modelsPath}.ClientGroup`
    const ignoredKeys = ['name', action.values ? 'countOfOrders' : 'values']

    const actionTranslation = Object.keys(
        Object.reject(action, ignoredKeys)
    ).filter(it => copiedAction[it]).map(it => {
        if (typeof copiedAction[it] === 'boolean') {
            copiedAction[it] = this.$vuetify.t(`$vuetify.${action[it]}`)
        }

        if (it == 'type') {
            copiedAction[it] = this.$vuetify.t(`$vuetify.pages.Groups.types.${copiedAction[it]}`)
        }

        if (it == 'values') {
            copiedAction[it] = (copiedAction[it] || []).join(' - ')
        }

        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation}: ${copiedAction[it]}`
    }).join('\n')

    return this.$vuetify.t(`${translationPath}.${type}`, copiedAction.name, actionTranslation)
}

function editClientGroup(type, actionItem) {
    const { action: { oldData, newData, name }} = actionItem

    if (!name || !oldData || !newData) {
        return ''
    }

    const copiedNewData = { ...newData } // Copy newData in order dont't change object properties directly

    const translate = (params, key) => this.$vuetify.t(`${translationPath}.${key}`, ...params)

    const changes = Object.entries(oldData).map(it => {
        const label = it[0]
        let value = it[1]

        const fieldTranslation = this.$vuetify.t(`${modelsPath}.ClientGroup.${label}`)

        if (label == 'accountId') {
            const prefix = copiedNewData[label] ? 'linkClients' : 'unlinkClients'
            const key = copiedNewData[label] || oldData[label]

            return translate([key], `${type}.${prefix}`)
        }

        if (['fromDate', 'toDate'].includes(label)) {
            value = formatDate(value)
            copiedNewData[label] = formatDate(copiedNewData[label])
        }

        if (label == 'type') {
            value = this.$vuetify.t(`$vuetify.pages.Groups.types.${value}`).toLowerCase()
            copiedNewData[label] = this.$vuetify.t(`$vuetify.pages.Groups.types.${copiedNewData[label]}`).toLowerCase()
        }

        if (label == 'values') {
            value = (value || []).join(' - ')
            copiedNewData[label] = (copiedNewData[label] || []).join(' - ')
        }

        if (typeof value === 'boolean') {
            value = isEnabled.call(this, value)
            copiedNewData[label] = isEnabled.call(this, copiedNewData[label])
        }

        return translate([fieldTranslation, value, copiedNewData[label]], `${type}.change`)
    })

    return `${translate([name], `${type}.result`)}:\n${changes.join('\n')}`
}

function remove(type, actionItem) {
    const { action: { name }} = actionItem

    return this.$vuetify.t(`${translationPath}.${type}`, name)
}

function createCashbackSystem(type, actionItem) {
    const { action } = actionItem
    const modelPath = `${modelsPath}.CashbackSystem`

    const result = Object.keys(action).map(it => {
        const fieldTranslation = this.$vuetify.t(`${modelPath}.${it}`)

        return `${fieldTranslation} - ${action[it]}`
    })

    return result.join('\n')
}

function editCashbackSystem(type, actionItem) {
    const { action: { name, oldData, newData }} = actionItem

    if (!name || !oldData || !newData) {
        return ''
    }

    const copiedNewData = { ...newData }

    const translate = (params, key) => this.$vuetify.t(`${translationPath}.${key}`, ...params)

    const changes = Object.entries(oldData).map(it => {
        const label = it[0]
        let value = it[1]

        const fieldTranslation = this.$vuetify.t(`${modelsPath}.CashbackSystem.${label}`)

        if (['fromDate', 'toDate'].includes(label)) {
            value = formatDate(value)
            copiedNewData[label] = formatDate(copiedNewData[label])
        }

        return translate([
            fieldTranslation,
            value,
            copiedNewData[label]
        ], `${type}.change`)
    })

    return `${translate([name], `${type}.result`)}:\n${changes.join('\n')}`
}

function changeCashbackSystemActivity(type, actionItem) {
    const { action: { name, enabled }} = actionItem

    return this.$vuetify.t(`${translationPath}.${type}`, name, isEnabled.call(this, enabled))
}

function login(type, actionItem) {
    const { remember } = actionItem.action

    return this.$vuetify.t(`${translationPath}.${type}`, remember)
}

function code(type, actionItem) {
    const { account: { email }, action: { code, name }} = actionItem

    return this.$vuetify.t(`${translationPath}.${type}`, email, code, name)
}

function changeServersFee(type, actionItem) {
    const { new: newData, old: oldData, name } = actionItem.action

    if (!newData || !oldData || !name) {
        return ''
    }

    return this.$vuetify.t(`${translationPath}.${type}`, name, oldData.fee, newData.fee)
}

function setToZeroServerBalance(type, actionItem) {
    const { name } = actionItem.action

    if (!name) {
        return ''
    }

    return this.$vuetify.t(`${translationPath}.${type}`, name)
}

function createAccount(type, actionItem) {
    const { type: roleName, email } = actionItem.action

    return this.$vuetify.t(`${translationPath}.${type}`, email, roleName)
}

function lockAccount(type, actionItem) {
    const { email, disabled } = actionItem.action
    const lockedTranslation = this.$vuetify.t(
        `$vuetify.pages.SystemLogs.messages.${disabled ? 'locked' : 'unlocked'}`
    )

    return this.$vuetify.t(`${translationPath}.${type}`, email, lockedTranslation)
}

function refillAccountBalance(type, actionItem) {
    const { sum, recipient: { email }} = actionItem.action

    return this.$vuetify.t(`${translationPath}.${type}`, email, parseFloat(sum) / 100)
}

function changeSettings(type, actionItem) {
    /**
     * This function is used for action types and all permissions changes translation.
     */

    const { changed } = actionItem.action
    const translationKey = type == 'change-permission'
        ? '$vuetify.pages.Roles.permissionsList'
        : '$vuetify.pages.SystemLogs.types'

    return (changed || []).map(it => {
        const { name, enabled } = it
        const nameText = this.$vuetify.t(`${translationKey}.${name}`)
        return this.$vuetify.t(`${translationPath}.${type}`, nameText, isEnabled.call(this, enabled))
    }).join('\n')
}

function changeAccountData(type, actionItem) {
    /**
     * This function is used to translate change-personal-data and change-admin-data action-logs.
     */
    const {
        account: { email },
        action: { oldData, newData, email: editedAccount }
    } = actionItem

    const translate = (params, key) => this.$vuetify.t(`${translationPath}.${key}`, ...params)

    if (oldData && newData) {
        [oldData, newData].forEach(it => it.role && Object.set(it, 'role', it.role.name))

        const changes = Object.entries(oldData).map((it, index) => {
            const [label, value] = it

            if (label === 'readTerms') {
                return translate([], `${type}.readTerms`)
            }

            const fieldTranslation = this.$vuetify.t(`$vuetify.pages.AdminEditor.${label}`)

            if (!value) {
                return translate([fieldTranslation, Object.values(newData)[index]], `${type}.add`)
            }

            return translate([fieldTranslation, value, Object.values(newData)[index]], `${type}.change`)
        }).join('\n')

        return `${translate([email, editedAccount], `${type}.user`)}:\n${changes}`
    }
}

function processNews(type, actionItem) {
    /**
     * This function is used for news logs translation.
     */
    const { account: { email }, action: { header }} = actionItem

    return this.$vuetify.t(`${translationPath}.${type}`, email, header)
}

function connectSocials(type, actionItem) {
    const { email } = actionItem.account

    return this.$vuetify.t(`${translationPath}.${type}`, email)
}

function pushNotification(type, actionItem) {
    const { action: { ios, android }, account: { email }} = actionItem

    const successAmount = ios.success + android.success
    const failureAmount = ios.failure + android.failure
    const total = [
        ios.success, android.success, ios.failure, android.failure
    ].reduce((a, b) => a + b)

    return this.$vuetify.t(`${translationPath}.${type}`, email, total, successAmount, failureAmount)
}

function fundsPurchase(type, actionItem) {
    const {
        action: { bonusSum, coefficient }
    } = actionItem

    return this.$vuetify.t(`${translationPath}.${type}`, parseInt(bonusSum) / 100, coefficient)
}

function fundsCharge(type, actionItem) {
    const {
        account: { type: accountType },
        action: {
            usersCount, refillSum, chargeRole,
            chargeType, accountId, dataAmount,
            beforeOrAfter, fromDate
        }
    } = actionItem

    const rolePath = `${accountType}.${chargeType}.${chargeRole}`
    const isBeforeText = this.$vuetify.t(`${translationPath}.${type}.${beforeOrAfter ? 'after' : 'before'}`)

    const chargeTypeAssoc = {
        all: [usersCount, refillSum],
        some: [accountId, refillSum],
        amount: [dataAmount, usersCount, refillSum],
        date: [isBeforeText, fromDate, usersCount, refillSum]
    }

    const translationParams = chargeTypeAssoc[chargeType]

    return this.$vuetify.t(`${translationPath}.${type}.${rolePath}`, ...translationParams)
}

const permissionsTranslation = function(permissions) {
    return permissions.map(permission => {
        return this.$vuetify.t(`$vuetify.pages.Roles.permissionsList.${
            permission.name
        }`).toLowerCase()
    }).join(', ')
}

function isEnabled(isEnabled) {
    const enabledText = isEnabled ? 'enabled' : 'disabled'

    return this.$vuetify.t(`$vuetify.pages.SystemLogs.messages.${enabledText}`)
}
